(function(){
    angular
        .module('appback')
        .directive('ngLecturaslist', lecturasList);

        lecturasList.$inject = ['socket','GenerallabService','MicrobiologiaService','$timeout', 'Upload', '$uibModal'];
        function lecturasList(socket,GenerallabService,MicrobiologiaService,$timeout, Upload, $uibModal){
            return {
	            //require: 'ngModel',
              templateUrl: '/backend/resultadopeticion/templateresultados?name=lecturaslist.twig',
		          scope: {
                    lc: '=',
                    peticionid: '=',
                    analiticaid: '=',
                    lecturas: '=',
                    finalizada: '=',
                    resembradoid: '=',
                    prefijo: '@'
              	},
            	link: function (scope, element, $attrs) {
                    //console.log("LECTURAS LIST SCOPE", scope);
                    scope.prefijo = scope.prefijo || '';
		            return $timeout(function () {

                        scope.editarLectura = function(lectura){
                            console.log("editar lectura", scope.peticionid, scope.analiticaid,lectura);

                            var modalInstance = $uibModal.open({
                                animation: true,
                                templateUrl: '/backend/resultadopeticion/templateresultados?name=editlectura.twig',
                                size: 'md',
                                controller: function($scope, $uibModalInstance) {
                                    $scope.dirScope = scope;
                                    $scope.dirScope.modal = $uibModalInstance;
                                    $scope.lectura_editable = lectura;
                                    $scope.koForm = function(){
                                        $uibModalInstance.close();
                                    }
                                }
                            });
                        }

                        scope.repetirPrueba = function(aislado, prueba){
                            console.log("repetir prueba", aislado.id, prueba);
                            MicrobiologiaService.changeEstadoTarea(aislado.id, prueba, function(data){
                                console.log("data change estado de tarea", data);
                                if(data.code>0){
                                    switch (prueba) {
                                        case 's':
                                            aislado.estado_antibiograma = !aislado.estado_antibiograma;
                                            aislado.user_updated_antibiograma = data.user_updated;
                                            aislado.antibiograma_data.last_update = data.last_update;
                                            break;
                                        case 'mt':
                                            aislado.estado_malditof = !aislado.estado_malditof;
                                            aislado.user_updated_malditof = data.user_updated;
                                            aislado.malditof_data.last_update = data.last_update;
                                            break;
                                        case 'r':
                                            aislado.estado_resiembra = !aislado.estado_resiembra;
                                            aislado.user_updated_resiembra = data.user_updated;
                                            aislado.resiembra_data.last_update = data.last_update;
                                            break;
                                    }
                                }
                            });
                        }
			        });	
		        }
            }
        }
})();